import { render, staticRenderFns } from "./newplatform.vue?vue&type=template&id=17360b30&scoped=true&"
import script from "./newplatform.vue?vue&type=script&lang=js&"
export * from "./newplatform.vue?vue&type=script&lang=js&"
import style0 from "./newplatform.vue?vue&type=style&index=0&id=17360b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17360b30",
  null
  
)

export default component.exports